import Icon from '@components/CustomIcon';
import ProgressBar from '@components/ProgressBar';
import * as styles from './index.css';

interface Props {
  percent: number;
  className?: string;
}

const FormProgress = ({ percent, className }: Props) => (
  <div className={[styles.container, className].filter(Boolean).join(' ')}>
    <div className={styles.row}>
      <ProgressBar percent={percent} className={styles.bar} />
      <div className={styles.secured}>
        <span className={styles.label}>Formulaire sécurisé</span>
        <Icon name='locker' size='xs' />
      </div>
    </div>
  </div>
);

export default FormProgress;
